import Splide from "@splidejs/splide"

let pageSliderSettings = {
  type: 'slide',
  perMove: 1,
  perPage: 3,
  pagination: false,
  arrows: 'slider',
  trimSpace: 'false',
  autoWidth: true,
  width: '100%',
  fixedWidth: '72rem',
  easing: 'ease',
  gap: '1rem',
  padding: {
    left: 0,
    right: 0,
  },
  classes: {
    arrows: 'splide__arrows',
    arrow: 'splide__arrow',
    prev: 'splide__arrow--prev',
    next: 'splide__arrow--next',
  },
  clones: 0,
  breakpoints: {
    1024: {
      perPage: 2,
    },
    640: {
      perPage: 1,
    },
  }
}

let testimonialSliderSettings = structuredClone(pageSliderSettings);
testimonialSliderSettings['trimSpace'] = true;
testimonialSliderSettings['autoWidth'] = false;
testimonialSliderSettings['fixedWidth'] = null;
testimonialSliderSettings['gap'] = '4rem';

/* Program Slider component needs to only be 2 slides wide */
let programSliderSettings = structuredClone(pageSliderSettings);
programSliderSettings['perPage'] = 2;

let cohortTextSliderSettings = structuredClone(pageSliderSettings);
cohortTextSliderSettings['perPage'] = 1;

export const testimonialSlider = ($el) => {
  const slidesNumber = $el.querySelectorAll('.splide__slide').length
  testimonialSliderSettings['perPage'] = slidesNumber < 3 ? slidesNumber : 3
  testimonialSliderSettings['breakpoints'] = {
    1279: {
      perPage: slidesNumber < 3 ? slidesNumber : 3,
    },
    1023: {
      perPage: slidesNumber < 2 ? slidesNumber : 2,
    },
    640: {
      perPage: 1,
    },
  }
  return initSlider($el, testimonialSliderSettings)
}

export const pageSlider = ($el) => {
  return initSlider($el, pageSliderSettings)
}

export const programSlider = ($el) => {
  return initSlider($el, programSliderSettings)
}

export const cohortTextSlider = ($el) => {
  return initSlider($el, cohortTextSliderSettings)
}

export const filterSlider = ($el, startFilterIndex = 0) => {

  let splide = new Splide($el, {
    start: startFilterIndex,
    fixedWidth: 100,
    autoWidth: true,
    autoHeight: true,
    gap: '1rem',
    arrows: false,
    pagination: false,
    slideFocus: false,
    focus: 'center',
  }).mount()

  function toggleGradients(splide) {
    const rectParent = splide.root.getBoundingClientRect()
    const rectFirstSlide = splide.root.querySelector('.splide__slide:first-child').getBoundingClientRect()
    const rectLastSlide = splide.root.querySelector('.splide__slide:last-child').getBoundingClientRect()

    if (rectFirstSlide.left >= rectParent.left) {
      splide.root.querySelector('#js-filter-left-gradient').classList.add('opacity-0')
    } else {
      splide.root.querySelector('#js-filter-left-gradient').classList.remove('opacity-0')
    }

    if (rectLastSlide.right <= rectParent.right) {
      splide.root.querySelector('#js-filter-right-gradient').classList.add('opacity-0')
    } else {
      splide.root.querySelector('#js-filter-right-gradient').classList.remove('opacity-0')
    }
  }

  toggleGradients(splide)

  splide.on('moved', function () {
    toggleGradients(splide)
  });
}

function initSlider($el, settings) {
  const splide = new Splide($el, settings)
  const Components = splide.Components

  splide.on('overflow', function (isOverflow) {
    splide.options = {
      arrows: isOverflow,
    }
  })

  splide.mount()

  toggleGradientInSlider(splide)

  splide.on('moved', function () {
    toggleGradientInSlider(splide)
  })
  splide.on('resized', function () {
    const isOverflow = Components.Layout.isOverflow()
    const arrowsContainer = splide.root.querySelector('.splide__arrows')
    arrowsContainer.style.display = isOverflow ? 'flex' : 'none'

    toggleGradientInSlider(splide)
  })

  return splide
}

function isSlideVisibleInViewport($el) {
  if (!$el) return false
  const rectElement = $el.getBoundingClientRect()
  const rectParent = $el.closest('.splide').getBoundingClientRect()
  return rectElement.right <= rectParent.right
}

function toggleGradientInSlider(splide) {
  const lastSlide = splide.root.querySelector('.splide__slide:last-child')
  if (isSlideVisibleInViewport(lastSlide)) {
    splide.root.querySelector('.fsa__section-slide-gradient').classList.add('opacity-0')
  } else {
    splide.root.querySelector('.fsa__section-slide-gradient').classList.remove('opacity-0')
  }
}